require('!style-loader!css-loader!video.js/dist/video-js.css');

var VideoJS = require('video.js');
var BaseViews = require('../common/base');
var VideoPlayer = BaseViews.ItemView.extend({
  template: require('./video-player/video-player.html'),
  className: 'container-fluid feature-popup-video-container',
  initialize: function (options) {
    this.options = _.defaults(
        options || {},
        {
            autoPlay: true,
            videoControls: true,
            videoUrl: null,
            width: 300,
            height: 300,
            muted: false,
            size: 'static' //static, scale
        }
    );
  },
  ui: {
    videoPlayer: '#video-player'
  },
  serializeData: function() {
    return {
      videoUrl: this.options.videoUrl
    }
  },
  setWidth: function (width) {
    if (this._videoPlayer !== null) {
      this._videoPlayer.width(width);
    }
  },
  setHeight: function (height) {
    if (this._videoPlayer !== null) {
      this._videoPlayer.height(height);
    }
  },
  _destroyVideoPlayer: function () {
    this._videoPlayer.dispose();
  },
  _setupVideoPlayer: function () {
    var self = this;
    var videoWidth;
    var videoHeight;

    if (this.options.size == 'scale') {
      videoWidth = $(window).width();
      videoHeight = $(window).height();
    } else {
      videoWidth = this.options.width;
      videoHeight = this.options.height;
    }

    var options = {
      width: videoWidth,
      height: videoHeight,
      controls : this.options.videoControls,
      muted: this.options.muted,
      controlBar: {
          children: {
            PlayToggle: true,
            muteToggle: true,
            VolumeControl: true,
            ProgressControl: true,
            RemainingTimeDisplay: true,
            FullscreenToggle: true
          }
      }
    };
    this._videoPlayer = new VideoJS(this.ui.videoPlayer[0], options, function onPlayerReady() {
      if (self.options.autoPlay == true) {
        this.play();
      }
      this.on('ended', function() {
        self.trigger('videoplayer:ended');
      });
    });
  },
  onRender:function () {
    this._setupVideoPlayer();
    BaseViews.ItemView.prototype.onRender.call(this);
  },
  onDestroy: function () {
    this._destroyVideoPlayer();
    BaseViews.LayoutView.prototype.onDestroy.call(self);
  }
});

module.exports = VideoPlayer;



/** WEBPACK FOOTER **
 ** ./assets/js/common/video-player.js
 **/